import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3a1346b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container outcome-content-container" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "stepper"
}

import axios from "axios";
import { computed, onBeforeMount, ref } from "vue";
import { useRoute } from "vue-router";
import Stepper from "../../components/team-outcomes/progress-stepper.vue";
import { csContext } from "../../services/cs-context";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-outcomes',
  setup(__props) {

const teamId = ref("");
const isTeamLeader = ref(false);
const isCompletePage = ref(false);
const step = ref(-1);
const displayStepper = ref(true);

const computedStep = computed(() => step.value);

function updateStepper(routeName: string): void {
  switch (routeName) {
    case "selectTeamOutcome":
      step.value = -1;
      break;
    case "selectTeamPathway":
      step.value = 0;
      break;
    case "viewPathway":
      step.value = 1;
      break;
    default:
      step.value = -1;
      break;
  }
}

const isTeamLeaderOrOrgAdmin = computed(
  () => isTeamLeader.value || csContext.userProfile.isOrgAdmin,
);

function handleCompletePage(value: boolean): void {
  isCompletePage.value = value;
}

function hideStepper(): void {
  displayStepper.value = false;
}

async function getTeamLeaderInfo(): Promise<void> {
  const response = await axios.get(`/api/teamuserpermissions/${teamId.value}`);
  isTeamLeader.value = response.data.isLeader;
}

const route = useRoute();

onBeforeMount(async () => {
  teamId.value = route.params.id as string;
  await getTeamLeaderInfo();
});

const backButtonLink = computed(() => {
  switch (route.name) {
    case "selectTeamPathway":
      return `/team/outcomes/${teamId.value}/select`;
    case "viewPathway":
      return `/team/outcomes/${teamId.value}/outcome/${route.params.outcomeUid}/select`;
    case "selectTeamOutcome":
    default:
      return `/home?view=TeamDashboard&teamId=${teamId.value}`;
  }
});

const backButtonText = computed(() => (route.name === "selectTeamOutcome" ? "My Team" : "Back"));

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "back-button btn btn-default-back",
        href: backButtonLink.value
      }, _toDisplayString(backButtonText.value), 9, _hoisted_3),
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, {
            isTeamLeaderOrOrgAdmin: isTeamLeaderOrOrgAdmin.value,
            onUpdateStepper: updateStepper,
            onHandleCompletePage: handleCompletePage,
            onHideStepper: hideStepper
          }, null, 8, ["isTeamLeaderOrOrgAdmin"])
        ]),
        _: 1
      }),
      (displayStepper.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (isTeamLeaderOrOrgAdmin.value && !isCompletePage.value && step.value !== undefined)
              ? (_openBlock(), _createBlock(Stepper, {
                  key: 0,
                  "completed-step": computedStep.value,
                  "steps-count": 3,
                  "show-tooltip": false
                }, null, 8, ["completed-step"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})